function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHrmsLogin4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M288.4,392s77.86,3.64,127.11-84.35-8.7-168.93-98.22-186.42S183.17,38.07,103.38,88.34,67.93,406.33,288.4,392Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.4,392s77.86,3.64,127.11-84.35-8.7-168.93-98.22-186.42S183.17,38.07,103.38,88.34,67.93,406.33,288.4,392Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.01,
    cy: 419.59,
    rx: 187.6,
    ry: 11.63,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 250.01,
    cy: 419.59,
    rx: 187.6,
    ry: 11.63,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.08,113.24l-.54,4.58,2.48.88a20.29,20.29,0,0,0,.65,4.65l-2.15,1.56,1.81,4.25,2.61-.49a20.2,20.2,0,0,0,2.88,3.7l-1.09,2.44,3.7,2.76,2-1.7a19.74,19.74,0,0,0,4.35,1.76l.28,2.65,4.57.55.89-2.49a20.29,20.29,0,0,0,4.65-.65l1.57,2.14L324,138l-.47-2.6a20.23,20.23,0,0,0,3.69-2.88l2.44,1.09,2.76-3.7-1.71-2a19.47,19.47,0,0,0,1.76-4.34l2.65-.28.55-4.58-2.49-.89a19.67,19.67,0,0,0-.65-4.64l2.16-1.57-1.82-4.25-2.6.48a20.28,20.28,0,0,0-2.89-3.69l1.08-2.43L324.73,99l-2,1.71a20.52,20.52,0,0,0-4.32-1.76l-.28-2.65-4.58-.54-.89,2.48a20.14,20.14,0,0,0-4.64.66l-1.57-2.15-4.25,1.81.48,2.6A20.2,20.2,0,0,0,299,104l-2.43-1.08-2.77,3.7,1.71,2a19.83,19.83,0,0,0-1.76,4.35Zm10.63,3.67a11.46,11.46,0,1,1,10,12.73h0a11.46,11.46,0,0,1-10-12.73Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "1.57112px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.61,225.94l-.49,4.15,2.25.8a18.19,18.19,0,0,0,.59,4.21l-2,1.42,1.64,3.85,2.36-.45a18.49,18.49,0,0,0,2.61,3.35l-1,2.21L181,248l1.81-1.55a17.71,17.71,0,0,0,3.94,1.6l.25,2.4,4.15.5.8-2.26a18,18,0,0,0,4.21-.59l1.42,1.95,3.84-1.65L201,246a18.49,18.49,0,0,0,3.35-2.61l2.21,1,2.5-3.34-1.55-1.83a17.92,17.92,0,0,0,1.6-3.93l2.4-.26.49-4.15-2.25-.8a18.19,18.19,0,0,0-.59-4.21l2-1.42-1.65-3.85-2.35.43a18.45,18.45,0,0,0-2.63-3.33l1-2.21L202.1,213l-1.82,1.55a17.81,17.81,0,0,0-3.92-1.59l-.25-2.4-4.15-.5-.8,2.26a18.11,18.11,0,0,0-4.21.59L185.53,211l-3.85,1.64.43,2.36a18.39,18.39,0,0,0-3.35,2.61l-2.21-1-2.5,3.35,1.55,1.82a18.2,18.2,0,0,0-1.6,3.94Zm9.63,3.32a10.38,10.38,0,1,1,9.08,11.54h0a10.39,10.39,0,0,1-9.08-11.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.08,327.75v-9.41l-5.25-1.19a40.53,40.53,0,0,0-2.44-9.26l4-3.69L374.67,296l-5.16,1.63a41.23,41.23,0,0,0-6.74-6.79l1.63-5.21-8.17-4.71-3.65,3.93a40.52,40.52,0,0,0-9.24-2.51l-1.2-5.3h-9.41l-1.2,5.26a40.15,40.15,0,0,0-9.26,2.44l-3.69-4-8.15,4.7,1.59,5.16a41.17,41.17,0,0,0-6.79,6.73l-5.2-1.61-4.7,8.14,3.94,3.67a40.57,40.57,0,0,0-2.51,9.23l-5.3,1.21v9.41l5.25,1.2a41.11,41.11,0,0,0,2.44,9.25l-4,3.7,4.71,8.17,5.15-1.59a40.79,40.79,0,0,0,6.76,6.76l-1.61,5.21,8.18,4.71,3.65-4a40.27,40.27,0,0,0,9.19,2.52l1.2,5.3h9.42l1.19-5.25a41.17,41.17,0,0,0,9.27-2.46l3.69,4,8.17-4.71-1.59-5.15a40.79,40.79,0,0,0,6.79-6.73l5.2,1.61,4.71-8.18-3.95-3.66a41.06,41.06,0,0,0,2.52-9.24Zm-16.27-4.86a29.54,29.54,0,1,1-29.54-29.54h0a29.54,29.54,0,0,1,29.54,29.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 94.15,
    width: 24.24,
    height: 5.59,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 102.23,
    width: 15.93,
    height: 5.59,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 110.31,
    width: 9.17,
    height: 5.59,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 94.15,
    width: 24.24,
    height: 5.59,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 102.23,
    width: 15.93,
    height: 5.59,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.34,
    y: 110.31,
    width: 9.17,
    height: 5.59,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.25,
    y: 156.07,
    width: 8.22,
    height: 16.84,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.12,
    y: 161.86,
    width: 8.22,
    height: 11.06,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 166.55,
    width: 8.22,
    height: 6.37,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.25,
    y: 156.07,
    width: 8.22,
    height: 16.84,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.12,
    y: 161.86,
    width: 8.22,
    height: 11.06,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 166.55,
    width: 8.22,
    height: 6.37,
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,185.66H151.41A10.39,10.39,0,0,1,141,175.27V93.1a10.41,10.41,0,0,1,10.39-10.39h99.53A10.4,10.4,0,0,1,261.33,93.1v82.17A10.39,10.39,0,0,1,250.94,185.66Zm-99.53-102a9.5,9.5,0,0,0-9.48,9.48v82.17a9.5,9.5,0,0,0,9.48,9.48h99.53a9.5,9.5,0,0,0,9.48-9.48V93.1a9.5,9.5,0,0,0-9.48-9.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 156.53,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 160.34,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 164.14,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 167.94,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 171.74,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 94.53,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 98.33,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 102.13,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 105.93,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.16,
    y: 109.73,
    width: 35.49,
    height: 0.91,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,125.23l6.36,3.34-.73-17.94-15.17,9.6,6.36,3.33-4.79,9.11h0a3.78,3.78,0,0,0-2.33.8l-8.45-3.91v-.05a3.88,3.88,0,0,0-7.75-.38h0a2.41,2.41,0,0,0,0,.38,4.05,4.05,0,0,0,.35,1.61l-11,12a3.7,3.7,0,0,0-1.09-.17,2.76,2.76,0,0,0-.57.06L188,122.9a3.87,3.87,0,0,0-7.08-3.11,3.71,3.71,0,0,0-.33,1.54,4.29,4.29,0,0,0,.2,1.17L162.74,141a3.87,3.87,0,1,0,2.31,5h0a4,4,0,0,0,.23-1.33,3.38,3.38,0,0,0-.13-.94L183.4,125a3.53,3.53,0,0,0,1.11.18,3.42,3.42,0,0,0,.71-.07l15.75,20a3.91,3.91,0,1,0,6.88,3.73,3.83,3.83,0,0,0,.47-1.65,2.54,2.54,0,0,0,0-.39,4,4,0,0,0-.2-1.19l11.26-12.26a3.57,3.57,0,0,0,.65.06,3.87,3.87,0,0,0,2.16-.66l8.6,4a3.87,3.87,0,1,0,7.73-.37,3.83,3.83,0,0,0-.69-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-2--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.17,196.27a5.91,5.91,0,0,0-5.9,5.91v51.21a5.9,5.9,0,0,0,5.9,5.9h62a5.91,5.91,0,0,0,5.91-5.9V202.15a5.91,5.91,0,0,0-5.91-5.9Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 203.25,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 208.39,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 213.53,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 218.68,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.98,
    y: 208.39,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.16,
    y: 223.82,
    width: 4.71,
    height: 0.63,
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.76,251.64a22.59,22.59,0,1,0-22.12-23,22.58,22.58,0,0,0,22.12,23Zm.79-38.54a16,16,0,1,1-16.32,15.67A16,16,0,0,1,286.55,213.1Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.76,251.64a22.59,22.59,0,1,0-22.12-23,22.58,22.58,0,0,0,22.12,23Zm.79-38.54a16,16,0,1,1-16.32,15.67A16,16,0,0,1,286.55,213.1Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,245.22a23,23,0,0,0,32.53.14.48.48,0,0,0,0-.64L297.84,240a.45.45,0,0,0-.32-.14.57.57,0,0,0-.33.13,15.36,15.36,0,0,1-11.28,4.51l-1.11,0a15.45,15.45,0,0,1-9.21-3.71c-.23-.21-.47-.42-.69-.64a15.79,15.79,0,0,1-1.75-20.27.41.41,0,0,0,.05-.09c.1-.14.21-.26.33-.4a15.47,15.47,0,0,1,13-5.86.45.45,0,0,0,.46-.44h0l.13-6.63a.46.46,0,0,0-.44-.47h0A23,23,0,0,0,270,245.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.69,206a23.51,23.51,0,1,1-.05,0Zm-.92,45.17a22.14,22.14,0,1,0-21.68-22.58h0A22.15,22.15,0,0,0,285.77,251.18Zm.79-38.54a16.42,16.42,0,1,1-16.75,16.08,16.42,16.42,0,0,1,16.75-16.08Zm-.65,31.91a15.51,15.51,0,1,0-15.19-15.82h0a15.51,15.51,0,0,0,15.19,15.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.67,
    y1: 278.13,
    x2: 169.67,
    y2: 338.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.27,
    y: 301.02,
    width: 5.15,
    height: 34.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.63,
    y: 315.19,
    width: 5.15,
    height: 20.55,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.28,
    y: 289.79,
    width: 5.15,
    height: 45.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.64,
    y: 283.16,
    width: 5.15,
    height: 52.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.01,
    y: 322.74,
    width: 5.15,
    height: 13.01,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.66,
    y: 304.7,
    width: 5.15,
    height: 31.05,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.64,
    y: 309.45,
    width: 5.15,
    height: 26.29,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.01,
    y: 289.05,
    width: 5.15,
    height: 46.69,
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.66,
    y: 299.36,
    width: 5.15,
    height: 36.38,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 327.71,
    x2: 167.02,
    y2: 327.71,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 320.22,
    x2: 167.02,
    y2: 320.22,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 312.74,
    x2: 167.02,
    y2: 312.74,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 305.25,
    x2: 167.02,
    y2: 305.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 297.76,
    x2: 167.02,
    y2: 297.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 290.27,
    x2: 167.02,
    y2: 290.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164.14,
    y1: 282.78,
    x2: 167.02,
    y2: 282.78,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.26,
    y1: 335.75,
    x2: 266.42,
    y2: 335.75,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.879169px"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.63,
    y: 315.19,
    width: 5.15,
    height: 20.55,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.01,
    y: 322.74,
    width: 5.15,
    height: 13.01,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.01,
    y: 289.05,
    width: 5.15,
    height: 46.69,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.05,269.71a6.52,6.52,0,0,0-6.51,6.51v59.51a6.53,6.53,0,0,0,6.51,6.52H270.5a6.54,6.54,0,0,0,6.52-6.52V276.2a6.53,6.53,0,0,0-6.52-6.52Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.65,402.74s2.31,15.42-3.28,17-9.47-.5-10.17-2.81,4.25-18.81,4.25-18.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.88,406.15l24.3,5.76s1.84,1,1.64,2.65-11.29,5.88-14.4,6.41-21.06,2.87-23.61.68S160.65,402,160.65,402Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,124.92s3.42,5.16,3.47,7.77-.27,5.59,1.33,7.13,2.83,3.22,2.17,4-1.93,2.3-1.93,2.3,1.65,8.79-.49,10.38-8.57,0-8.57,0v5.68s-9.14-3-15.45-2.44l-1.12-12.17S119,121.21,125.88,124.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,160.88s-.82-6.24,2.22-10c0,0-3.64-.62-3.2-1.94s6,.41,6,.41l-1.5-3s-5.25-1.74-4.6-3.37,8.35,2.38,8.35,2.38-4.57-3.82-3.93-5.41,5.29-1.56,7.77,6.68l1.26-1.57s.45-9.38,1.74-9.89c0,0,2,1.1,2,6.49,0,0,2,2.41.73,4.45s-4.26,6.63-6.8,8.35-2.53,8.43-2.53,8.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.62,109.59l1.15-1.54s12.87-5.74,12.55-7.53-7.61.68-9-.27c0,0,1.33-16.94,0-17.49s-2.81,7.95-2.81,7.95-1.87-8.72-3.31-8.47-.84,9-.84,9-2.75-5.61-3.82-5.09.53,7.36.53,7.36-2-2.35-2.8-1.64A26.51,26.51,0,0,0,96.12,102l-2.78,4.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.71,160.92l8.87,1.24s-6.49,55-8.4,61.79-3.63,11.67-10.15,12-29.75-19.2-29.75-19.2l-1.08,27,1.51,11.2s-28.41,14.93-57.3,1.94l.65-13.14L74.65,183.65l-8.19-28.54L92.89,105l9.58,5-16.9,45.61,4.73,15.23,5.29-2.12,5.85-7.46s9.92-5.15,22.47,2l2,6.26s14.72,1.11,39.57,35.56Z",
    style: {
      fill: "#0B1D51"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3,160.92l1.12,7.7S126.68,174.1,130,176c0,0,8.12,51.28,2.11,61.37l-6.33,9.91s6.47,0,9.45-4.53c0,0-3.71,12.38-13.33,15.71,0,0,14.77-1.54,19.85-3.5l-1.51-11.2,2.43-62.45s2.29-4.18-16.75-11.67l-2.81-6.75Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.88,125.62s3.1,4.54,3.47,7.07-.73,5.32,1.33,7.13,3,3,2.17,4-1.93,2.3-1.93,2.3.84,8.57-.49,10.38-8.57,0-8.57,0v5.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.86,145.74s-2.9-7.49-5.07-5.68-.24,11.71,5.07,9.54",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.07,144s3.45-.28,1.27-8.37,2.54-7,7.61-9.3,6.28-6.52,5.19-9.05-2.9-3.87-9.3-2.66c0,0-7-8.09-13.76.85,0,0-15.22-.24-19.32,7s1.33,25.72,9.3,31.88,15.76,1.23,17.38-4.56c0,0-5.43-2.93-2.65-9.69C116.79,140.06,119.32,139.16,121.07,144Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,179.09s36.83-26.71,68.93,0l-2.59,64.62,1.51,11.2s-27.14,12.71-57.3,1.94l.65-13.14Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1,169.38l6.34-8.08s12.43-4.3,22.47,2l2,6.26",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142.79,
    y1: 179.09,
    x2: 174.86,
    y2: 215.97,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.31,216s21.25,19.77,29.72,20,9.88-10,9.88-10l8.67-63.8-8.87-1.24-15.26,44.23",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43,162s1.11-7.21,4-8.85,6.32-8,5.22-9.83-4.46,4.12-7.49,5.26-5.49,6.74-5.91,9.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.72,143.06s0-8.33-1.53-7.94-1.74,10.94-1.74,10.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.33,147.13s-1-4.67-3.75-6.95-4.47-1.05-4.16-.28,5,7,4.89,9.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.57,144.82s-7.55-3.46-7.57-1.39,4.6,2.87,4.6,2.87l1.5,3s-6.36-2-6-.41,3.2,1.94,3.2,1.94-3.09,3.06-2.22,10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.34,255.66l1.93,13.52s17.77,53.31,20.47,63.73,4.25,34,5,44.81,7,29,7,29-.77,7.34-13.9,6.18c0,0-5.41-21.63-11.2-34.38S140,346.43,140,346.43l-28.2-51.76s-5.77,30.14-9.65,41.33c-4,11.54-31.27,75.57-29.36,71.08,0,0-3.86,2.32-12-3.48,0,0,5.79-19.31,7.33-29.74s9.66-34.38,9.66-34.38,1.93-45.19,5-59.1c0,0-2-15.32,2.27-26.14A91.92,91.92,0,0,0,137.34,255.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "96.35 285.59 109.01 289.27 110.85 293.76",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.12,411.32s-1.71,8.57-.31,10.33c.74.92,2.94.75,4,.77,2.44.05,4.89-.11,7.33-.27,4.88-.32,9.88-.27,14.59-1.78A46.41,46.41,0,0,0,195,415.26c1.92-1.28,0-3.35,0-3.35l-23.25-5.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,418.63s26.13,4.29,37-6.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8,402.74s-3,10.29-2.56,13.53,3.69,4,7.49,3.91,5.36-1.79,5.92-4.36,0-10.88,0-10.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59.2,
    y1: 414.7,
    x2: 72.65,
    y2: 415.82,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.31,105.32c1.14-2.08,1.81-3.35,1.81-3.35S92.41,93,93.34,91.9s3.08,2,3.08,2-2.2-7.13-.81-7.74,3.87,6,3.87,6-.65-9.55.79-10,3.17,9.08,3.17,9.08,1.86-8.48,3-8.56,0,17.49,0,17.49c2.3,1.13,9.06-1.63,9,.6s-13,7.36-13,7.36a5.78,5.78,0,0,0-.59.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "73.86 179.09 66.46 155.11 92.89 105.03 102.47 110.04 85.57 155.65 90.3 170.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.72,151.32s9.48-.08,10.85,4.33a19,19,0,0,0-11.71,3.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.04,
    y1: 160.26,
    x2: 106.04,
    y2: 153.31,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63,198.43,145,214.2s1.94-10.29,3.15-10.29,0,12.06,0,12.06,19.88,18,28.48,18.1c0,0-4.78,3.36-9.57.86s-25.79-19-25.79-19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.77,109.15,82.59,153.31s-6.33-.1-8.73,5.58l9.72-1.74,3.27,15,3.45-1.31-4.73-15.23L102.47,110Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.31 186.81 344.15 171.52 316.01 190.11 339.23 231.25 357.34 220.97 351.31 186.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.5,319.06s4.55,12.63,5.22,18.78-1.38,32.05-.94,39.19,4.3,28.45,4.3,28.45-18.93,13.76-24.94,9.33c0,0,13.34-10.8,14.69-15.1l-4.32-29.19L364.22,336s-1.09-7.21-2.61-10.92-1.29-11.58-1.29-11.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.1,317.94s4.92,13.3,6.07,22.85S377.86,372,379,382.43s2.31,16.2,4.33,21.69l-1,16.11h-2.59l-1-9.14s-4.06-1.69-6.52,4.16-11.55,6.62-15.86,3.23c0,0,0-2.62,3.24-4.93s11.7-9.53,13.24-13.84c0,0-4.62-30-5.7-39.72s-2.77-27.39-4.93-33.09-2.15-13.85-2.15-13.85",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.34,401.1S369.65,414.9,359,414.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.14,414.81a11.26,11.26,0,0,0,5.2-.65c2.87-1,13.2-6,18.28-12.31l1.56,1.77-.82,16.24-2.61.37-1-9.14s-3.34-1.53-5.49,2.23-3.7,6.34-7.46,7.17-9.43-2-9.43-2S355.38,417,358.14,414.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.35,319.49a115.94,115.94,0,0,0,4.34,12.91c2.27,5.21,21.88,57.9,21.88,57.9s1.49,28.52,9.84,28.43-.33-19.93-.33-19.93L414,387.93s-1.94-31.93-4.34-43.67l-10.22-27.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.55,317.65s8.39,19.09,10.12,26.61,3.47,41.35,4.34,43.67,14.75,26.89,6.36,31.81S410,391.4,410,391.4s-19.37-53.8-22.27-59-6.07-20.25-6.07-20.25Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422,407.13s-.58,6.66-2.78,7.6-7.06-6.57-7.06-6.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.18,409.31s3,11.36,7,10.88,4.72-6.79,2.83-11.66c0,0-.67,5-2.78,6.2C417.1,414.76,412.18,409.31,412.18,409.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.77,218.35s10.11,13.8,17.12,36,6.29,64.72,6.29,64.72-26.09,8.39-51.38-2.27L353.43,221S369.7,221.3,376.77,218.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.71,118.27s-7.86,7.36-8.78,12.18a37.81,37.81,0,0,1-3.62,9.67,7.05,7.05,0,0,0,3.53,2.76s.51,9.87,3.38,10.63l6.86-1.8.73,4.23,9.84-3.74v-5.7l7.5-4.9-2.67-12.81-12.2-5.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.38,220.23l-.87-13.84s-6.4-12-4.37-16.36c2.24-4.79,15.7-22.53,15.7-22.53l-1.32-9.68,18.86-8.08.9,8.08L380,159.51l2.53,5.42s.16-1.61,4.54,6.56,20.88,37.24,22.18,42.82-25.66,25.24-34.76,29.88c0,0-1.05-2.25-11.86,6-2.75-.48-6.55-2.95-7.36-4.48s3.11-5.17,3.11-5.17,2.36-4.46,6.53-.89h4.44L394.76,216l-12.88-18.85-5.11,21.17S360.24,223.34,353.38,220.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.52 157.82 363.87 167.71 382.28 157.82 381.38 149.74 362.52 157.82",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.87,167.71s-16.75,20.49-16.3,24.53,4.94,14.15,4.94,14.15l.92,14.6s13.55.37,23.34-2.64l5.11-21.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.76,216l-25.95-39.12s-2.55-9,3.59-12.21,11.48.86,13.39,3,22.51,41.83,23.47,46.6-20.8,23.85-33.39,29c0,0-5.73,3.44-5.73-3.62Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 382.28,
    y1: 164.93,
    x2: 379.85,
    y2: 159.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.14,239.69h-5.22s-4.07-3.64-6,0-4.37,4.36-3.64,6.06,4.91,5.09,7.36,4.48S372,244,372,244",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.83,120.86s-6.13,5.36-6.81,8.33-.39,8-3.71,10.93c0,0,.17,2.4,3.53,2.76,0,0,1.72,9.47,3.38,10.63s11.82-4.08,15.8-6.24a5.27,5.27,0,0,0,2.09-2.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,145.77a7.72,7.72,0,0,0,4.76-2.81",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,132.07s2.42-1.41,3.75.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.73,137.1c0,.81-.23,1.47-.6,1.49s-.71-.62-.75-1.42.23-1.48.6-1.5S358.69,136.29,358.73,137.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 365.08,
    y1: 151.71,
    x2: 365.89,
    y2: 156.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94,136.48s1.5-2.91,3.17-1.21,4.84,9.56-3.71,7.69c0,0-.57,4.8,3.71,6s12.41-5.42,12.68-16.71-10.63-18.91-16.39-16.73c0,0-8.35-13.09-16.63-7.51s-2.7,14.17-4.46,16.11-5.52.12-5.64,5.33,8.59,4.68,8.59,4.68l1.05-5.74,7.21-7.53s-1.7,5.44,1.19,10.17C366.32,135.29,372.94,136.48,372.94,136.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.79,132.25s4,.9,3.56,6.31-9.47,18.71-8.79,26.37l23.31,43.44s10.49-2,10-12.8-13.29-19.9-10.82-27.86,12.17-28.23-1.57-39.85-35.16,6.19-35.16,6.19l10.49-3.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "350.41 185.92 344.15 171.52 316.01 190.11 339.23 231.25 353.31 223.5",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.77,210.46s-1.52-3.14.51-4.87,9-6.86,9-5.6a2.2,2.2,0,0,1-.48,1.73c-2,2.68-6.79,7-6.48,7.35,0,0,8.74-5.8,9.58-5.25.21.14.09.89-.64,1.62a75.63,75.63,0,0,1-7.57,5.92s9.22-3.57,10.41-3c.34.16.27.68-.8,1.33a84.1,84.1,0,0,1-8.25,3.92l2.31,3.86S328,218.23,324.77,210.46Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.01,
    y1: 145.77,
    x2: 375.65,
    y2: 152.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrmsLogin4);
export default __webpack_public_path__ + "static/media/HRMS-Login-4.e079bb3291e8449c69a2941a9fbb888f.svg";
export { ForwardRef as ReactComponent };